import { Outlet } from 'react-router-dom';

import { PageSeo } from '@/seo';

/**
 * No public chrome.
 *
 * Used by the auth screens and by both dashboards, which render their own
 * sidebar and top bar.
 */
export const BareLayout = () => (
  <main className="flex-1 text-left">
    <PageSeo page="account" />
    <Outlet />
  </main>
);
